module.exports = __webpack_public_path__ + "assets/img/0d04-lu.svg";